module.exports = __webpack_public_path__ + "img/Icon-block-team-32px.e0c6889f.svg";